import { createAsyncThunk } from "@reduxjs/toolkit";
import { useGetData } from "../../../hooks/useGetData";
import { useInsertData } from "../../../hooks/useInsertData";
import notify from "../../../components/notify";
import { useDeleteData } from "../../../hooks/useDeleteData";
import i18n from "../../../i18n/i18n";

export const getAllBookings = createAsyncThunk(
  "/bookingSlice/getAllBookings",
  async ({ query }, { rejectWithValue }) => {
    try {
      const response = await useGetData(`/bookings/client?${query}`);
      return response;
    } catch (error) {
      if (error.message === "Network Error") {
        notify(i18n.t("network_error_message"), "error");
        return rejectWithValue(i18n.t("network_error_message"));
      } else {
        notify(error.response?.data?.message, "error");
        return rejectWithValue(error.response?.data?.message);
      }
    }
  },
);
export const getOneBooking = createAsyncThunk(
  "/bookingSlice/getOneBooking",
  async (id, { rejectWithValue }) => {
    try {
      const response = await useGetData(`/bookings/${id}`);
      return response;
    } catch (error) {
      if (error.message === "Network Error") {
        notify(i18n.t("network_error_message"), "error");
        return rejectWithValue(i18n.t("network_error_message"));
      } else {
        notify(error.response?.data?.message, "error");
        return rejectWithValue(error.response?.data?.message);
      }
    }
  },
);
export const cancelBooking = createAsyncThunk(
  "/bookingSlice/cancelBooking",
  async (id, { rejectWithValue }) => {
    try {
      const response = await useInsertData(`/bookings/${id}/cancel`);
      return response;
    } catch (error) {
      if (error.message === "Network Error") {
        notify(i18n.t("network_error_message"), "error");
        return rejectWithValue(i18n.t("network_error_message"));
      } else {
        notify(error.response?.data?.message, "error");
        return rejectWithValue(error.response?.data?.message);
      }
    }
  },
);
export const createBooking = createAsyncThunk(
  "/bookingSlice/createBooking",
  async ({ data }, { rejectWithValue }) => {
    try {
      const response = await useInsertData(`/bookings/web`, data);
      return response;
    } catch (error) {
      if (error.message === "Network Error") {
        notify(i18n.t("network_error_message"), "error");
        return rejectWithValue(i18n.t("network_error_message"));
      } else {
        notify(error.response?.data?.message, "error");
        return rejectWithValue(error.response?.data?.message);
      }
    }
  },
);


export const getAllBookingTimes = createAsyncThunk(
  "/bookingSlice/getAllBookingTimes",
  async ({ query = "" }) => {
    try {
      const response = await useGetData(
        `/bookings/reserved-times?${query}`,
      );
      return response;
    } catch (error) {
      if (error.message === "Network Error") {
        return notify(i18n.t("network_error_message"), "error");
      } else {
        return notify(error.response?.data, "error");
      }
    }
  },
);
